import { render, staticRenderFns } from "./materialDetails.vue?vue&type=template&id=da7c61ec&scoped=true&"
import script from "./materialDetails.vue?vue&type=script&lang=js&"
export * from "./materialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7c61ec",
  null
  
)

export default component.exports